
<kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
            [groupable]="true" [resizable]="true" [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
            (sortChange)="sortChange($event)" style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize"
            [pageable]="true">

  <ng-template kendoGridToolbarTemplate position="top">
    <button  (click)="onAddClick()" kendoButton class="btn btn-primary" [hidden]="!canUpdate">
      <fa-icon icon="circle-plus"></fa-icon> Add Discipline Subscale </button>
  </ng-template>

  <kendo-grid-column title="Edit" [width]="70">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button  (click)="onEditClick(dataItem)" kendoButton class="btn btn-stn-grid" [hidden]="!canUpdate">
        <fa-icon icon="edit"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Sort Order" [width]="90">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onUpClick(dataItem)" kendoButton class="btn btn-stn-grid mr-1" *ngIf="rowIndex != 0" [hidden]="!canUpdate" style="margin-right: 4px">
        <fa-icon icon="arrow-up"></fa-icon>
      </button>
      <button (click)="onDownClick(dataItem)" kendoButton class="btn btn-stn-grid" *ngIf="rowIndex != gridData.length - 1 "[hidden]="!canUpdate">
      <fa-icon icon="arrow-down"></fa-icon>
    </button>

    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="subscale_description" title="Subscale Description"
                     [width]="200"
                     [filterable]="false"
                     [sortable]="false"></kendo-grid-column>


  <kendo-grid-column title="Activate / Deactivate" field="active" [width]="130" [filterable]="false" [sortable]="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active" (click)="setActive(dataItem)" [disabled]="!canUpdate" />
    </ng-template>
  </kendo-grid-column>


  <ng-template kendoPagerTemplate>
    <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
  </ng-template>

</kendo-grid>

<kendo-dialog-actions>
  <button kendoButton (click)="onCancelAction()" class="btn btn-primary">Close</button>
</kendo-dialog-actions>
